import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { StorageManager } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';
import { Button } from '@atlas/ui';

import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';
import { CXFROM_STORAGE_KEY } from 'common/constants';

const BetslipSignInButton = () => {
  const { setIsOpenPopup } = useLocalBetslip();
  const history = useHistory();
  const { pathname } = useLocation();

  const onClick = useCallback(() => {
    setIsOpenPopup(false);
    StorageManager.setItem(CXFROM_STORAGE_KEY, pathname);
    history.push(staticRoutes.signin);
  }, [setIsOpenPopup, history, pathname]);

  return <Button label="betslip_place_auth_required" onClick={onClick} size="big" type="primary" />;
};

export default BetslipSignInButton;
